import {Feature} from '../features';
import {type PaymentRequestOptions, type PaymentRequestUpdateOptions} from '@stripe/stripe-js';
import {FeatureFlag} from '../../../@type/features';
import {type PayDetails, type PeachPayCheckoutData} from '../types';

declare const peachpay_checkout_data: PeachPayCheckoutData;

const SUPPORTED_ZERO_DECIMAL_CURRENCIES = [
	'BIF',
	'CLP',
	'DJF',
	'GNF',
	'JPY',
	'KMF',
	'KRW',
	'MGA',
	'PYG',
	'RWF',
	'UGX',
	'VND',
	'VUV',
	'XAF',
	'XOF',
	'XPF',
];

function createPaymentRequestOptions(): PaymentRequestOptions {
	let details: PayDetails;
	if (peachpay_checkout_data.page.is_order_pay && peachpay_checkout_data.order_pay_details) {
		details = peachpay_checkout_data.order_pay_details;
	} else {
		details = peachpay_checkout_data.cart_details;
	}

	const data: PaymentRequestOptions = {
		country: Feature.metadata<string>(FeatureFlag.STRIPE_GATEWAYS, 'country') ?? 'US',
		currency: details.currency.toLowerCase(),
		total: {
			label: details.total_line.label,
			amount: formatCurrency(details.total_line.amount, details.currency),
		},
		displayItems: details.item_lines.map(l => ({
			label: l.label,
			amount: formatCurrency(l.amount, details.currency),
		})),
	};

	return data;
}

function updatePaymentRequestOptions(): PaymentRequestUpdateOptions {
	const data: PaymentRequestUpdateOptions = {
		currency: peachpay_checkout_data.cart_details.currency.toLowerCase(),
		total: {
			label: peachpay_checkout_data.cart_details.total_line.label,
			amount: formatCurrency(peachpay_checkout_data.cart_details.total_line.amount, peachpay_checkout_data.cart_details.currency),
		},
		displayItems: peachpay_checkout_data.cart_details.item_lines.map(l => ({
			label: l.label,
			amount: formatCurrency(l.amount, peachpay_checkout_data.cart_details.currency),
		})),
	};

	return data;
}

function formatCurrency(amount: string, currencyCode: string): number {
	let total = Number.parseFloat(amount);

	if (!SUPPORTED_ZERO_DECIMAL_CURRENCIES.includes(currencyCode)) {
		total *= 100;
	}

	return Math.round(total);
}

export {
	createPaymentRequestOptions,
	updatePaymentRequestOptions,
};
